import { FaEdit } from "react-icons/fa";
import "./TransactionsTable.css";

const TransactionsTable = ({ data, onEdit, canEdit }) => {
  return (
   <div className="table-wrapper">
 <table className="transaction-table">
      <thead>
        <tr>
          {canEdit && <th>Edit</th>}
          <th>Date</th>
          <th>Scrip</th>
          <th>Buy/Sell</th>
          <th>Quantity</th>
          <th>Rate</th>
          <th>B.Amt/R.Amt</th>
          <th>Share Amount</th>
          <th>Commission</th>
          <th>C.Rate</th>
        </tr>
      </thead>

      <tbody>
        {data.map((tx) => {
          const shareAmount = (tx.quantity * tx.rate).toFixed(2);
          const commission = (
            tx.transactionType === "BUY"
              ? tx.amount - shareAmount
              : shareAmount - tx.amount
          ).toFixed(2);

          return (
            <tr key={tx.id}>
              {canEdit && (
  <td>
    <FaEdit
      className="edit-icon"
      onClick={() => onEdit(tx)}
      style={{ cursor: "pointer" }}
    />
  </td>
)}
              <td>{tx.date}</td>
              <td>{tx.scrip}</td>
              <td>{tx.transactionType}</td>
              <td>{tx.quantity}</td>
              <td>{tx.rate}</td>
              <td>{tx.amount}</td>
              <td>{shareAmount}</td>
              <td>{commission}</td>
              <td>{(tx.amount / tx.quantity).toFixed(2)}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
   </div>
  );
};

export default TransactionsTable;